import * as React from 'react';

import { FeaturesLayout, FeaturesItem } from '../../../../components/FeaturesNew';
import { useFeaturesAdditionallyProps } from './hooks';

export const FeaturesAdditionally: React.FC = () => {
  const featuresProps = useFeaturesAdditionallyProps();

  if (!featuresProps) {
    return null;
  }

  return (
    <FeaturesLayout title={featuresProps.title}>
      {featuresProps.featuresList.map(({ name, theme }) => (
        <FeaturesItem key={name} name={name} theme={theme} />
      ))}
    </FeaturesLayout>
  );
};
